/// REDUX ///
import { Dispatch } from "redux";
/// ACTIONS ///
import { Action } from "api/action_types/shop_quote";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_quote";

export const deleteLocalShopCutShapes = (counter_uuid: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.DELETE_LOCAL_SHOP_CUT_SHAPE,
      payload: counter_uuid
    });
  }
}
